var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-M---Header-Menu-L1",
    transform: "translate(-25.000000, -526.000000)",
    fill: "#1D1C1C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-dei-servizi",
    transform: "translate(0.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact-us-icon",
    transform: "translate(25.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4097573,12.7177316 L17.4097573,9.18379562 C18.3680372,9.2147333 19.1384529,9.99436272 19.1384529,10.9506569 C19.1384529,11.9071645 18.3680372,12.6867939 17.4097573,12.7177316 M10.6063577,18.1465469 L9.28656835,18.1465469 C9.09353355,18.1465469 8.93647733,17.9910051 8.93647733,17.7998316 C8.93647733,17.6086581 9.09353355,17.4531162 9.28656835,17.4531162 L10.6063577,17.4531162 C10.799177,17.4531162 10.9564487,17.6086581 10.9564487,17.7998316 C10.9564487,17.9910051 10.799177,18.1465469 10.6063577,18.1465469 M0.86176252,10.9506569 C0.86176252,9.99436272 1.63239365,9.21451993 2.59045813,9.18379562 L2.59045813,12.7177316 C1.63239365,12.6867939 0.86176252,11.9071645 0.86176252,10.9506569 M17.4097573,8.3303425 L17.4097573,7.33820326 C17.4097573,3.29176867 14.0857238,0 10.0001077,0 C5.91470705,0 2.59045813,3.29176867 2.59045813,7.33820326 L2.59045813,8.3303425 C1.15734706,8.36149354 0,9.52368332 0,10.9506569 C0,12.39726 1.18858596,13.5739585 2.64884255,13.5739585 L3.02133939,13.5739585 C3.25918585,13.5739585 3.45222065,13.382785 3.45222065,13.1472319 C3.45222065,13.1459517 3.45178977,13.1446715 3.45178977,13.1433914 C3.45178977,13.1421112 3.45222065,13.140831 3.45222065,13.1395508 L3.45222065,7.33820326 C3.45222065,3.76244806 6.38975364,0.853453116 10.0001077,0.853453116 C13.6106772,0.853453116 16.5479948,3.76244806 16.5479948,7.33820326 L16.5479948,12.9827288 L12.7700279,17.373105 L11.737421,17.373105 C11.562914,16.9216283 11.122338,16.5996631 10.6059268,16.5996631 L9.28635291,16.5996631 C8.61805608,16.5996631 8.07449937,17.1379787 8.07449937,17.7998316 C8.07449937,18.4616844 8.61805608,19 9.28635291,19 L10.6059268,19 C11.1221225,19 11.562914,18.6780348 11.737421,18.2265581 L12.9688796,18.2265581 C13.0951278,18.2265581 13.2149128,18.1717238 13.2965648,18.0765637 L17.1712645,13.5739585 L17.3513729,13.5739585 C18.8118449,13.5739585 20,12.3970466 20,10.9506569 C20.0002154,9.52368332 18.8430838,8.36149354 17.4097573,8.3303425",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/assistance.96c2da9b0e680b2307eb8742dc475b26.svg";
export { ForwardRef as ReactComponent };